import { jsxs as h, jsx as t } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import e from "./styles.module.less.js";
const N = p(
  (o, r) => {
    const {
      title: f,
      value: n,
      disabled: c,
      onChange: m,
      className: s,
      hideLabel: d,
      titleClassName: i,
      switchButtonClassName: a,
      getTranslation: l,
      error: $
    } = o, u = () => {
      m(!n);
    };
    return /* @__PURE__ */ h(
      "div",
      {
        ref: r,
        ...o.props,
        className: `${e.onOffInputContainer} ${s || ""} ${$ ? e.error : ""}`,
        children: [
          /* @__PURE__ */ t(
            "div",
            {
              className: `${e.onOffInputTitle} ${i || ""}`,
              children: f
            }
          ),
          !d && /* @__PURE__ */ t("div", { className: `${e.onOffInputValue}`, children: l(n ? "confirm.on" : "confirm.off") }),
          /* @__PURE__ */ t(
            "div",
            {
              className: `${e.switchButton} ${n ? e.on : e.off} ${c ? e.disabled : ""} ${a || ""}`,
              onClick: u,
              children: /* @__PURE__ */ t(
                "div",
                {
                  className: `${e.switchButtonCircle} ${n ? e.on : e.off}`
                }
              )
            }
          )
        ]
      }
    );
  }
);
N.displayName = "OnOffInput";
export {
  N as OnOffInput
};
